import { Text } from '@/components/commons/typography/Text'
import { ArrowDownIcon } from '@/public/assets/v2/images/icons'
import { Collapsible } from '@/components/collapsible/Collapsible'
import { useContext, useState } from 'react'
import { cssClass } from '@/shared/utils'
import {
  arrowCollapsibleIcon,
  arrowCollapsibleIconOpen,
} from '../styles/layouts.css'
import { BrowserContext } from 'context'

interface CollapsibleLayoutProps {
  children: React.ReactNode
  onOpenChange?: (isOpen: boolean) => void
}

export const CollapsibleLayout = ({
  children,
  onOpenChange,
}: CollapsibleLayoutProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const { isMobile } = useContext(BrowserContext)

  return (
    <Collapsible
      onOpenChange={(isOpen: boolean) => {
        setIsCollapsed(isOpen)
        onOpenChange(isOpen)
      }}
    >
      {isMobile ? (
        <>
          <Collapsible.Content>
            <div className="flex flex-column gap-16">{children}</div>
          </Collapsible.Content>
          <Collapsible.Trigger className="bg-white-primary border-0 full-w">
            <div className="flex items-center justify-center mt-16 gap-6">
              <Text variation="small">
                {isCollapsed ? 'Less' : 'More'} Details
              </Text>
              <div className="pt-4">
                <ArrowDownIcon
                  className={cssClass([
                    'text-14',
                    arrowCollapsibleIcon,
                    isCollapsed && arrowCollapsibleIconOpen,
                  ])}
                />
              </div>
            </div>
          </Collapsible.Trigger>
        </>
      ) : (
        <div className="flex flex-column gap-16">{children}</div>
      )}
    </Collapsible>
  )
}
